// Геймплейные параметры в исходных значениях. Спрайты у героя/врагов в 2× больше
// (display), но body в Player/Enemy переопределён на оригинальный размер коллизии
// — поэтому физика и геометрия мира остаются как раньше.
export const PLAYER_CONFIG = {
  // Движение
  walkSpeed: 260,
  jumpVelocity: -680,
  doubleJumpVelocity: -560,
  maxFallSpeed: 900,
  coyoteTime: 100,
  jumpBuffer: 120,
  jumpCutMultiplier: 0.25,

  // Рывок: ≈220px (~2.2 ширины героя) за 220мс
  dashSpeed: 1000,
  dashDuration: 220,
  dashCooldown: 600,

  // Бой
  nailDamage: 5,
  nailRange: 60,
  nailCooldown: 410,
  pogoBounceVelocity: -500,

  // Ресурсы
  maxHP: 5,
  maxSoul: 99,
  soulPerHit: 11,
  focusCost: 33,
  focusDuration: 950,
  invincibilityAfterHit: 1100,

  // Получение урона
  hurtKnockbackX: 240,
  hurtKnockbackY: -260,
  enemyContactDamage: 1,

  // Заклинание (Vengeful Spirit)
  spellCost: 33,
  spellDamage: 15,
  spellCastLockout: 220,
  spellCooldown: 600,
  spellProjectileSpeed: 720,
  spellProjectileLifetime: 1500,

  // Wall jump / slide
  wallSlideSpeed: 180,
  wallJumpKick: 380,
  wallJumpLockout: 180,
};

export const PORTAL_CONFIG = {
  restDelay: 250,
};
